import React, { useState } from "react";
import { useSelector } from "react-redux";
import { CustomCard } from "../../../CustomCard";
import { Icon } from "@iconify/react";
import CartIcon from "../../../../../assets/CartIcon";

export const ServiceCard = ({
  data,
  user_profile_id,
  handleCalenderOpen,
  calendar,
  serViceList,
  shipInstructions,
  handleChangeSplInstructions,
}) => {
  const [showMore, setShowMore] = useState(false);
  const { refsdata } = useSelector((state) => state.refstypes);
  const {
    svc_name,
    svc_cat_desc,
    svc_typ_desc,
    svc_desc,
    svc_cost_amt,
    svc_provider_local_cost_amt,
    svc_id,
    svc_photo1,
  } = data;
  const xchange_rate = refsdata.usr?.iso_currency_xchng || [];
  const shouldText = svc_desc.length > 100;
  const displayText = showMore
    ? svc_desc
    : `${svc_desc.slice(0, 100)}${shouldText ? "..." : ""}`;
  const toggleShowMore = () => {
    setShowMore(!showMore);
  };

  const svc_cost_amtf = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(svc_cost_amt);

  const svc_provider_local_cost_amtf = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(svc_provider_local_cost_amt);

  return (
    <CustomCard className="facility patient-card">
      <div
        className="d-flex justify-content-between align-items-center !mb-4"
        style={{ borderBottom: "1px solid #E7E7E9" }}
      >
        <div className="d-flex align-items-center justify-content-center gap-2">
          <div className="flex gap-2">
            {svc_photo1 ? (
              <img
                src={svc_photo1}
                className="w-12 h-12 rounded-full"
                alt="service"
              />
            ) : (
              <Icon
                icon="streamline-emojis:hospital"
                style={{ fontSize: "40px" }}
              />
            )}

            <div>
              <h5 className="!text-base m-0 !text-main">{svc_name}</h5>
              <p className="!text-description !font-normal">
                #{svc_id} &nbsp;
                {displayText}
                {shouldText && (
                  <span onClick={toggleShowMore}>
                    {" "}
                    {showMore ? "Show Less" : "Show More"}
                  </span>
                )}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="row gap-y-[18px]">
        <div className="col-6">
          <small>Service Category :</small>
          <p className="truncate mb-0">{svc_cat_desc}</p>
        </div>
        <div className="col-6">
          <small>Service Type:</small>
          <p className="truncate mb-0">{svc_typ_desc}</p>
        </div>
        <div className="col-6">
          <small> {xchange_rate[0]?.iso_curr_name}:</small>
          <p className="truncate mb-0">{svc_provider_local_cost_amtf}</p>
        </div>
        <div className="col-6">
          <small>Service Code (USD) :</small>
          <p className="truncate mb-0">{svc_cost_amtf}</p>
        </div>
        <div className="col-12">
          <small>Special Instructions (Optional) </small>
          <textarea
            placeholder="Example: Please also test for diabetes"
            className="form-control"
            id="customTextInput"
            rows="2"
            value={shipInstructions[svc_id] || ""}
            onChange={(e) =>
              handleChangeSplInstructions(svc_id, e.target.value)
            }
            style={{
              padding: "5px",
              fontSize: "14px",
              width: "100%",
            }}
          />
        </div>

        <div className="flex flex-col justify-start gap-2">
          <button
            className="sign_btn !w-full !text-xs !flex !justify-center !items-center !gap-2"
            style={{ boxSizing: "border-box" }}
            onClick={() => {
              handleCalenderOpen(
                svc_id,
                calendar,
                serViceList,
                user_profile_id
              );
            }}
          >
            <CartIcon /> <span className="mt-[2px]">Add To Cart</span>
          </button>
        </div>
      </div>
    </CustomCard>
  );
};
